import Boton from "./Boton";
import "../Info.css"

const VRS = ()=>{  return(
    <div className="infoalbum">
<h1 className="title">Versus: VirtuouS </h1>
<div className="infoal">
<div className="infotext">
    <Boton/>
<p>- Beneficio de Preventa (POBs) = desde <span className="colorunoa">8usd</span> <span className="colordosa"> 10 usd</span></p>
        <p className="ver">LIMITADO (ver. B)</p>
        <p>- Photobook Limitado (cd+pb) = <span className="colorunoa">13usd</span> <span className="colordosa"> 10 usd</span></p>
        <p>- Photocard limitada = <span className="colorunoa">3,8usd</span> <span className="colordosa"> 10 usd</span></p>
        <p>- character card = <span className="colorunoa">2,5usd</span> <span className="colordosa"> 5 usd</span></p>
        <p>- Postcards(Set ot7) = <span className="colorunoa">1usd c/u</span> <span className="colordosa"> 7 usd set</span></p>
        <p>- Poster preventa (double sided)= <span className="colorunoa">1,5usd</span> <span className="colordosa"> 1 usd</span></p>
        <p>- Stickers =  <span className="colorunoa">0,8usd</span> <span className="colordosa"> 0,5 usd</span></p>
        <p className="ver">NORMAL (ver. R-E-A-K)</p>
        <p>- Photobook (cd+pb) = <span className="colorunoa">8usd</span> <span className="colordosa"> 8 usd</span></p>
        <p>- Photocard = <span className="colorunoa">4usd</span> <span className="colordosa"> 2 usd</span></p>
        <p>- Stickers = <span className="colorunoa">0,8usd</span> <span className="colordosa"> 0,5 usd</span></p>
        <p>- Postcard =<span className="colorunoa">1,5usd</span> <span className="colordosa"> 2 usd</span></p>
        <p>- Poster preventa ( double sided )= <span className="colorunoa">1,5usd</span> <span className="colordosa"> 1 usd</span></p>
        <p className="ver">POCA</p>
        <p>- Pacakge + standee= <span className="colorunoa"> 4 usd</span><span className="colordosa"> 2usd</span> </p>
        <p>- Photocard = <span className="colorunoa">6usd</span> <span className="colordosa"> 4 usd</span></p>
        <p>- QR Photocard =<span className="colorunoa">4usd</span> <span className="colordosa"> 4 usd</span></p>
        <p>- Stickers =  <span className="colorunoa">1usd</span> <span className="colordosa"> 0,5 usd</span></p>
</div>
<div className="infoalimg ">
<img src="https://pbs.twimg.com/media/GSc0ssDXUAEcZ_s?format=jpg&name=4096x4096" alt="Album Cover"  style={{ boxShadow: "3.5px 3.5px 0px rgb(55, 146, 243)" }}/>
<img src="https://pbs.twimg.com/media/GSc0t8AWEAEfEjG?format=jpg&name=4096x4096" alt="Album Cover"  style={{ boxShadow: "3.5px 3.5px 0px rgb(55, 146, 243)" }}/>
</div>
</div>
</div>

)}
export default VRS;
